/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_3_CtaInputs */

const en_mk_parts_3_cta = /** @type {(inputs: Mk_Parts_3_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how they work`)
};

const id_mk_parts_3_cta = /** @type {(inputs: Mk_Parts_3_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat cara kerjanya`)
};

/**
* | output |
* | --- |
* | "See how they work" |
*
* @param {Mk_Parts_3_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_3_cta = /** @type {((inputs?: Mk_Parts_3_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_3_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_3_cta(inputs)
	return en_mk_parts_3_cta(inputs)
});